import { FC } from 'react';

interface Props {
  author_name?: string;
  author_profile_picture?: string;
  formattedName: () => string | undefined;
  imagePlaceholder?: string;
}

const PromptCardAuthor: FC<Props> = ({ author_name, author_profile_picture, formattedName, imagePlaceholder }) => {
  return (
    <div className="flex items-center gap-2">
      <span className="text-gray-600 text-sm font-medium">{formattedName()}</span>
      <img
        src={author_profile_picture || `https://placehold.co/32x32/0a1f44/ffffff?text=${imagePlaceholder}`}
        alt={author_name || "Author Avatar"}
        className="w-8 h-8 rounded-full object-cover border border-gray-200"
      />
    </div>
  );
};

export default PromptCardAuthor;
